<template>
  <div class="j-map-demo-layout" style="height: 600px;">
    <el-button @click="showDzdt">电子地图</el-button>
    <el-button @click="showYxdt">影像地图</el-button>
    <el-button @click="showGrid(true)">显示网格</el-button>
    <el-button @click="showGrid(false)">关闭网格</el-button>
    <el-button @click="getxzqh">获取行政区划</el-button>
    <el-button @click="showqy(true, '区')">显示区</el-button>
    <el-button @click="showqy(false, '区')">关闭区</el-button>
    <el-button @click="showqy(true, '街道')">显示街办</el-button>
    <el-button @click="showqy(false, '街道')">关闭街办</el-button>
    <el-button @click="showqy(true, '社区')">显示社区</el-button>
    <el-button @click="showqy(false, '社区')">关闭社区</el-button>
    <el-button @click="measureArea">面积测量</el-button>
    <el-button @click="measurePonint">坐标测量</el-button>
    <el-button @click="measureDistance">距离测量</el-button>
    <el-button @click="clearDistance">清除测量结果</el-button>
    <el-button @click="draw('point')">开始绘制点</el-button>
    <el-button @click="draw('polyline')">开始绘制线</el-button>
    <el-button @click="draw('polygon')">开始绘制面</el-button>
    <el-button @click="drawRange">创建范围区域</el-button>
    <el-button @click="openre">打开存储的资源标注面</el-button>
    <el-button @click="getNode">获取绘制资源点位和代码</el-button>
    <el-button @click="clearDraw">清除绘制区域</el-button>
    <el-button @click="drawPoint">指定位置画图标点</el-button>
    <el-button @click="drawGroupPoint">指定位置画组合点位</el-button>
    <el-button @click="drawPointByList">根据数组画点位集合</el-button>
    <el-button @click="drawGroupPointByList">根据数组画组合点位</el-button>
    <el-button @click="clearPoint">清除所画点位</el-button>
    <el-button @click="lightPoint">高亮指定点</el-button>
    <JMap ref="map"
               env="development"
               @load="mapLoadEvent"
               @click="mapClickEvent"
               @hit="pointHitEvent"
               @focus="mapFocusEvent"
               @blur="mapBlurEvent"
               @drag="mapDragEvent"
               @db-click="mapDBClickEvent"
               @mouse-wheel="mapMouseWheelEvent"
               @draw-complete="drawComplete"
    >
      <JMapControl slot="control" class="j-map-demo-ctrl" :control="control" :position="{top: 15, right: 15}" @change="ctrlChange">
        <div slot="地图类型" class="device-map-ctrl-popup">
          <div class="device-map-ctrl-popup-item text" @click="$refs.map.JMapShowElectronMap()">电子地图</div>
          <div class="device-map-ctrl-popup-item text" @click="$refs.map.JMapShowSimulationMap()">影像地图</div>
        </div>
        <div slot="行政区划" class="device-map-ctrl-popup">
          <div class="device-map-ctrl-popup-item"><el-checkbox label="网格" @change="$refs.map.JMapToggleExpandGridLayer($event)"/></div>
          <div class="device-map-ctrl-popup-item"><el-checkbox label="区" @change="$refs.map.JMapToggleExpandSubjectLayer($event,'区')"/></div>
          <div class="device-map-ctrl-popup-item"><el-checkbox label="街办" @change="$refs.map.JMapToggleExpandSubjectLayer($event,'街办')"/></div>
          <div class="device-map-ctrl-popup-item"><el-checkbox label="社区" @change="$refs.map.JMapToggleExpandSubjectLayer($event,'社区')"/></div>
        </div>
        <div slot="辅助工具" class="device-map-ctrl-popup">
          <div class="device-map-ctrl-popup-item text" @click="$refs.map.JMapToolMeasureCoordinate()">坐标测量</div>
          <div class="device-map-ctrl-popup-item text" @click="$refs.map.JMapToolMeasureDistance()">距离测量</div>
          <div class="device-map-ctrl-popup-item text" @click="$refs.map.JMapToolMeasureArea()">面积测量</div>
          <div class="device-map-ctrl-popup-item text" @click="$refs.map.JMapDrawGraphicResources('polygon')">资源标注</div>
        </div>
      </JMapControl>
    </JMap>
  </div>
</template>

<script>
import JMap from "@/components/JComponents/JMap/components/JMap.vue";
import JMapControl from "@/components/JComponents/JMap/components/JMapControl.vue";
export default {
  name: 'JMapDemo',
  components: {
    JMap,
    JMapControl
  },
  data () {
    return {
      control: [
        { name: '地图类型', class: 'custom-dtlx' },
        { name: '摄像机', class: 'custom-sxj', tag: true },
        { name: '行政区划', class: 'custom-xzqh' },
        { name: '辅助工具', class: 'custom-tool' },
        { name: '资源图层', class: 'custom-tc' },
        { name: '我的资源', class: 'custom-zy' }
      ],
      curPoint: {}
    }
  },
  methods: {
    ctrlChange (data) {
      console.log(data)
      this.control[1].tag = false
    },
    mapLoadEvent () {
      console.log('地图加载完事件(渲染点位的事件需要在次事件后执行)')
    },
    mapClickEvent (event) {
      console.log('地图点击事件', event)
      this.curPoint = {
        latitude: event.mapPoint.latitude,
        longitude: event.mapPoint.longitude,
        x: event.mapPoint.x,
        y: event.mapPoint.y
      }
    },
    mapDBClickEvent (event) {
      console.log('地图双击点击事件', event)
    },
    mapFocusEvent (event) {
      console.log('地图聚焦事件', event)
    },
    mapMouseWheelEvent (event) {
      console.log('地图鼠标滚轮事件', event)
    },
    drawComplete (data) {
      console.log('地图绘画结束事件', data)
    },
    mapDragEvent (event) {
      console.log('地图拖拽事件', event)
    },
    pointHitEvent (event) {
      console.log('点位点击事件', event)
    },
    mapBlurEvent (event) {
      console.log('地图失焦事件', event)
    },
    drawRange () {
      console.log('创建范围')
      this.$refs.map.JMapDrawGraphicCircleRange({
        x: 120.6310444225605,
        y: 36.18886276210807
      }, 1000)
    },
    showDzdt () {
      this.$refs.map.JMapShowElectronMap()
    },
    showYxdt () {
      this.$refs.map.JMapShowSimulationMap()
    },
    showGrid (flag) {
      this.$refs.map.JMapToggleExpandGridLayer(flag)
    },
    getxzqh () {
      console.log(this.$refs.map.JMapGetExpandSubjectLayer())
    },
    showqy (flag, type) {
      this.$refs.map.JMapToggleExpandSubjectLayer(flag, type)
    },
    measureDistance () {
      this.$refs.map.JMapToolMeasureDistance()
    },
    clearDistance () {
      this.$refs.map.JMapClearMeasure()
    },
    measurePonint () {
      this.$refs.map.JMapToolMeasureCoordinate()
    },
    measureArea () {
      this.$refs.map.JMapToolMeasureArea()
    },
    draw (type) {
      this.$refs.map.JMapDrawGraphicResources(type)
    },
    openre () {
      this.$refs.map.JMapRenderPolygon('POLYGON((120.41530518628143 36.30954696646273,120.46461701171667 36.279051495469886,120.43801457957397 36.22844199041792,120.3861073949053 36.23233502926807,120.36145148218768 36.27191425757794,120.37832131720499 36.29786784991228,120.41530518628143 36.30954696646273))')
    },
    clearDraw () {
      this.$refs.map.JMapClearGraphicResources()
    },
    getNode () {
      console.log(this.$refs.map.JMapGetGraphicStorage())
    },
    clearPoint () {
      this.$refs.map.JMapClearPoint()
    },
    lightPoint () {
      this.$refs.map.JMapDrawActivePoint({
        longitude: 120.3828388967112,
        latitude: 	36.264635947555306,
        type: 3
      })
    },
    drawPoint () {
      this.$refs.map.JMapDrawPoint({
        longitude: 120.3828388967112,
        latitude: 	36.264635947555306
      }, true)
    },
    drawGroupPoint () {
      this.$refs.map.JMapDrawGroupPoint({
        name: '组合点位一个位置包含多个图片或文字',
        longitude: 120.3828388967112,
        latitude: 	36.264635947555306
      })
    },
    drawGroupPointByList () {
      this.$refs.map.JMapRenderPointArray([
        {
          longitude: 120.3828388967112,
          latitude: 	36.264635947555306,
          text: '文字描述1'
        },
        {
          longitude:	120.2378231995431,
          latitude:	36.32108501088249,
          text: '文字描述2'
        }
      ], 'group')
    },
    drawPointByList () {
      this.$refs.map.JMapRenderPointArray([
        {
          longitude: 120.3828388967112,
          latitude: 	36.264635947555306,
          type: 1
        },
        {
          longitude:	120.2378231995431,
          latitude:	36.32108501088249,
          type: 2
        }
      ])
    }
  }
}
</script>

<style lang="scss">
.j-map-demo-layout {
  .device-map-ctrl-popup {
    padding: 10px;
    box-sizing: border-box;
    width: 124px;
    border: 2px solid rgba(41,109,121, .5);
    box-shadow: 0px 0px 5px 3px rgba(0,0,0,.6);
    border-radius: 10px;
    &.filtrate-popup {
      width: 300px;
      .j-label-wrap .el-radio {
        margin: 0!important;
      }
      .el-radio.is-bordered {
        height: 24px;
        width: 58px;
        color: #fff;
        .el-radio__input {
          display: none;
        }
        border-radius: 0px 8px 0 8px;
      }
      .j-label-wrap {
        display: flex;
        .j-label-wrap_label {
          font-size: 12px;
          color: #E8F5FF;
          width: 70px;
          text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
        }
        .j-grid-wrap {
          flex: 1;
          min-width: 50px;
        }
        .el-radio {
          &.qb-radio {
            border-color: #2ce7f7; box-shadow: -2px -2px 1px rgba(44,231,247, 0.4);
            &.is-checked {
              background-color: #2ce7f7 ;
              .el-radio__input.is-checked + .el-radio__label {
                color: #000;
              }
            }
          }
          &.zx-radio { border-color: #6adf2e; box-shadow: -2px -2px 1px rgba(106,223,46, 0.4); margin: 0 8px!important;
            &.is-checked {
              background-color: #6adf2e ;
              .el-radio__input.is-checked + .el-radio__label {
                color: #000;
              }
            }
          }
          &.lx-radio { border-color: #cad3e0; box-shadow: -2px -2px 1px rgba(202,211,224, 0.4);
            &.is-checked {
              background-color: #cad3e0 ;
              .el-radio__input.is-checked + .el-radio__label {
                color: #000;
              }
            }
          }
          &.bj-radio { border-color: #fd5c69; box-shadow: -2px -2px 1px rgba(253,92,105, 0.4); margin: 8px 0 0!important;
            &.is-checked {
              background-color: #fd5c69 ;
              .el-radio__input.is-checked + .el-radio__label {
                color: #000;
              }
            }
          }
          &.gz-radio { border-color: #fcef5b; box-shadow: -2px -2px 1px rgba(252,239,91, 0.4); margin: 8px 0 0 8px!important;
            &.is-checked {
              background-color: #fcef5b ;
              .el-radio__input.is-checked + .el-radio__label {
                color: #000;
              }
            }
          }
        }

      }
      .el-radio--mini.is-bordered {
        padding: 0;
        height: 24px;
        line-height: 20px;
        text-align: center;
        .el-radio__label{
          padding: 0!important;
        }
      }
    }
    .device-map-ctrl-popup-item {
      display: flex;
      align-items: center;
      padding-left: 10px;
      box-sizing: border-box;
      width: 100%;
      height: 28px;
      border-radius: 4px;
      font-family: Alibaba-PuHuiTi-R;
      font-size: 12px;
      color: #1BE1F3;
      font-weight: 400;
      background-color: rgba(27,225,243, .1);
      .el-checkbox__label {
        color: #1BE1F3;
      }
      + .device-map-ctrl-popup-item {
        margin-top: 10px;
      }
      &.text {
        display: block;
        padding: 0;
        line-height: 28px;
        text-align: center;
      }
    }
  }
  .j-map-demo-ctrl {
    background-color: transparent;
    box-shadow: none;
    .j-map-control-item {
      width: 56px;
      height: 56px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 44px;
      + .j-map-control-item {
        margin-left: 20px;
      }
      .j-map-control-popup {
        position: absolute;
        top: 72px;
        right: -20px;
        background-color: rgba(17,23,32, .9);
      }
      &.j-map-control-tag {
        &::before {
          content: '';
          position: absolute;
          height: 16px;
          width: 16px;
          background-size: cover;
          background-image: url("../../components/JComponents/JMap/assets/point-style2.png");
          background-color: transparent;
          right: -3px;
          top: 9px;
          border-radius: 0;
        }
      }
      &.custom-dtlx {
        background-image: url("../../components/JComponents/JMap/assets/point-people.png");
      }
      &.custom-sxj {
        background-image: url("../../components/JComponents/JMap/assets/point-people.png");
      }
      &.custom-xzqh {
        background-image: url("../../components/JComponents/JMap/assets/point-other.png");
      }
      &.custom-zy {
        background-image: url("../../components/JComponents/JMap/assets/point-build.png");
      }
      &.custom-tool {
        background-image: url("../../components/JComponents/JMap/assets/point-people.png");
      }
      &.custom-tc {
        background-image: url("../../components/JComponents/JMap/assets/point-public.png");
      }
      &.j-map-control-active {
        &.custom-dtlx {
          background-image: url("../../components/JComponents/JMap/assets/point-people.png");
        }
        &.custom-sxj {
          background-image: url("../../components/JComponents/JMap/assets/point-public.png");
        }
        &.custom-xzqh {
          background-image: url("../../components/JComponents/JMap/assets/point-people.png");
        }
        &.custom-zy {
          background-image: url("../../components/JComponents/JMap/assets/point-public.png");
        }
        &.custom-tool {
          background-image: url("../../components/JComponents/JMap/assets/point-build.png");
        }
        &.custom-tc {
          background-image: url("../../components/JComponents/JMap/assets/point-other.png");
        }
        .j-map-control-item-text {
          box-shadow: 0px 1px 1px 0px #FFF861;
          background-image: linear-gradient(180deg, rgba(34,53,95,0.80) 0%, rgba(15,24,49,0.10) 100%);
        }
      }
      .j-map-control-item-text {
        position: absolute;
        bottom: -2px;
        width: 56px;
        height: 20px;
        font-family: Alibaba-PuHuiTi-M;
        font-size: 12px;
        color: #FFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 18px;
        font-weight: 500;
        border-radius: 2px;
        box-shadow: 0px 1px 1px 0px #1be1f3;
        background-image: linear-gradient(180deg, rgba(34,53,95,0.80) 0%, rgba(15,24,49,0.10) 100%);
      }
    }
  }
}
.gis-demo-input {
  .el-input__inner {
    background: transparent!important;
    border: none;
  }
}
</style>
